import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { reduce } from "et3-type-guards";
import { borderWidths, fontWeights, sizes } from "et3-ui-library";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import getDashBoardStore from "../../stores/dashboard-store";
import et3ReadableDate from "../../helpers/et3-date-helper";
import getCoreTimingStore from "../../stores/core/core-timing-store";

const UserInfo = withLiteObserverAndTheme(() => {
  const user = getCorePersonalStore().user.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const username = reduce(() => user.username, "");
  const isLoading = getCoreUIStore().isLatestDataLoading.get();
  const activeTime = getDashBoardStore().activeTime.get();
  const countDownTime = isAnyKhattabaAdmin
    ? getCoreTimingStore().khattabatCountDownTime.get() * 1000
    : getCoreTimingStore().countDownTime.get() * 1000;
  const userImageName = getCorePersonalStore().userPofilePic.get();
  const isMobileNav = getCoreUIStore().isMobileNav.get();

  return (
    <Stack
      alignItems="center"
      spacing={0.5}
      sx={{ px: 2, pt: 3, pb: 2, textAlign: "center" }}
    >
      {isMobileNav ? (
        <Avatar
          src={require(`../../assets/images/${userImageName}.png`)}
          alt={i18n.get("ALKHATTABA_ADMIN")}
          sx={{
            width: sizes.avatar.lg,
            height: sizes.avatar.lg,
            mb: 1,
            border: `${borderWidths.thin}px solid`,
            borderColor: "primary.main"
          }}
        />
      ) : null}
      <Typography
        variant="subtitle1"
        fontWeight={fontWeights.semibold}
        sx={{ wordBreak: "break-word" }}
      >
        {username}
      </Typography>
      <Box
        sx={{
          minHeight: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {isLoading ? (
          <CircularProgress size={14} />
        ) : (
          <Typography variant="body2" color="success.main">
            {`${i18n.get("ACTIVE")} - ${et3ReadableDate(activeTime)}`}
          </Typography>
        )}
      </Box>
      <Typography variant="body2" color="text.secondary">
        {`${i18n.get("REFRESH")} - ${et3ReadableDate(countDownTime)}`}
      </Typography>
    </Stack>
  );
});
export default UserInfo;
